import { funcoesDoContato } from '@/domain/contatos/agrupar';

interface EtiquetasFuncaoProps {
  contato: { funcoes?: readonly string[] | null; role: string };
  className?: string;
}

/**
 * Funções de um contato como etiquetas — GUPM-202 (contato único por pessoa).
 * Uma pessoa com duas funções aparece num cartão só, com as duas etiquetas.
 * Usada no modal 🚨, na Cobertura Técnica, no PAEBM e na aba Contatos.
 */
export function EtiquetasFuncao({ contato, className = '' }: EtiquetasFuncaoProps) {
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`}>
      {funcoesDoContato(contato).map((f) => (
        <span
          key={f}
          className="rounded border border-jf-border bg-white/5 px-1.5 py-px text-[10px] leading-tight text-jf-muted"
        >
          {f}
        </span>
      ))}
    </span>
  );
}
